up.compiler('[training-ground-summary]', (element) => {
  const map = document.querySelector('[training-grounds-search--map]')
  const searchForm = document.querySelector('.training-grounds--search')

  function init() {
    map.addEventListener('app:map:pinClicked', loadSummary)
    map.addEventListener('app:map:rowClicked', loadSummary)
  }

  function loadSummary(event) {
    let pinData = event.pinData
    let urlParams = ''

    if (pinData.filterParams) {
      urlParams = getUrlParams(pinData.filterParams)
    }

    let url = pinData.url + '/summary?' + urlParams

    up.navigate(element, { url, history: false, layer: 'current' })
    searchForm.classList.add('hidden')
    up.emit('app:sidebar:show')
  }

  function getUrlParams (params, keys = [], isArray = false) {
    const p = Object.keys(params).map(key => {
      let val = params[key]

      if ("[object Object]" === Object.prototype.toString.call(val) || Array.isArray(val)) {
        if (Array.isArray(params)) {
          keys.push("")
        } else {
          keys.push(key)
        }
        return getUrlParams(val, keys, Array.isArray(val))
      } else {
        let tKey = key

        if (keys.length > 0) {
          const tKeys = isArray ? keys : [...keys, key]
          tKey = tKeys.reduce((str, k) => { return "" === str ? k : `${str}[${k}]` }, "")
        }
        if (isArray) {
          return `${ tKey }[]=${ val }`
        } else {
          return `${ tKey }=${ val }`
        }

      }
    }).join('&')

    keys.pop()
    return p
  }

  init()
})
